import { createMapExportEntry } from '~/client/src/shared/components/MapExport/createMapExportEntry'
import { IMapExportEntry } from '~/client/src/shared/components/MapExport/MapExport.store'
import * as e from '~/client/src/shared/stores/EventStore/eventConstants'
import InitialState from '~/client/src/shared/stores/InitialState'

import MapViewSetUpStore from '../../views/ProjectSetUp/components/AppsSitemap/MapViewSetUp.store'

// Map Setup hands its live map to the export as the Workflows map does, with no Workflows. Never
// mid-save, while a plan is being aligned, or while a placement queue waits for its next item; a
// half-edited item is saved or discarded first. isSaving reads the host's own observable, never its
// props: canOpen is a computed, and mobx-react refuses props read in a derivation.
export function createMapSetupExportEntry(
  setUp: MapViewSetUpStore,
  state: InitialState,
  isSaving: () => boolean,
): IMapExportEntry {
  const items = setUp.mapViewItemsSetupStore
  const entry = createMapExportEntry(setUp, state, items.leaveSelectionThen)
  return {
    ...entry,
    isAvailable: () =>
      entry.isAvailable() &&
      !isSaving() &&
      !state.loading.get(e.SAVE_GLOBE_VIEW) &&
      !setUp.mapBoxEditorStore.isRubberMode &&
      !items.isSitemapBlocked &&
      !items.pendingPlacement.id,
    readSeed: () => ({ ...entry.readSeed(), hasWorkflows: false }),
  }
}
